import React from "react";
import Container from "@mui/material/Container";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import SpeechSynthesis from "./Components/SpeechSynthesis";
import SpeechRecognition from "./Components/SpeechRecognition";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";

export default function App() {
  return (
    <Router>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              React Translator
            </Typography>
            <Button color="inherit" component={Link} to="/recognition">
              Recognizer
            </Button>
            <Button color="inherit" component={Link} to="/synthesis">
              Synthesizer
            </Button>
          </Toolbar>
        </AppBar>
      </Box>
      <Container
        sx={{
          p: 3,
          mt: 5,
          display: "flex",
          flexDirection: "column",
          justify: "contentCenter",
          alignItems: "center",
        }}
        maxWidth="sm"
      >
        <Switch>
          <Route path="/recognition">
            <SpeechRecognition />
          </Route>
          <Route path="/synthesis">
            <SpeechSynthesis />
          </Route>
          <Route path="*">
            <Redirect to="/recognition" />
          </Route>
        </Switch>
      </Container>
    </Router>
  );
}
